/* TermPaymentAmount.ts */
import { Currency } from "../utils/Currency";
export class TermPaymentAmount {
    /* — model props — */
    _termNumber;
    _paymentAmount;
    _active = true;
    /* — JS / binding props — */
    jsTermNumber;
    jsPaymentAmount;
    jsActive;
    /* — misc — */
    _modified = false;
    get modified() {
        return this._modified;
    }
    set modified(v) {
        this._modified = v;
    }
    /* ─────────────────────────────────────────── */
    constructor(params) {
        this.termNumber = params.termNumber;
        this.paymentAmount = params.paymentAmount;
        this.active = params.active ?? true;
        this.updateJsValues();
    }
    /* ===== active ===== */
    get active() {
        return this._active;
    }
    set active(v) {
        this._active = v;
        this.jsActive = v;
        this.modified = true;
    }
    /* ===== termNumber ===== */
    get termNumber() {
        return this._termNumber;
    }
    set termNumber(v) {
        this._termNumber = v;
        this.jsTermNumber = v;
        this.modified = true;
    }
    /* ===== paymentAmount ===== */
    get paymentAmount() {
        return this._paymentAmount;
    }
    set paymentAmount(v) {
        this._paymentAmount = v instanceof Currency ? v : new Currency(v);
        this.jsPaymentAmount = this._paymentAmount.toNumber();
        this.modified = true;
    }
    /* ===== helpers ===== */
    updateJsValues() {
        this.jsTermNumber = this.termNumber;
        this.jsPaymentAmount = this.paymentAmount.toNumber();
        this.jsActive = this.active;
    }
    updateModelValues() {
        this.termNumber = this.jsTermNumber;
        this.paymentAmount = this.jsPaymentAmount;
        this.active = this.jsActive;
    }
    /* ===== serialization ===== */
    get json() {
        return {
            termNumber: this.termNumber,
            paymentAmount: this.paymentAmount.toNumber(),
            active: this.active,
        };
    }
    toJSON() {
        return this.json;
    }
}
